import { PollingConfig } from '../data'

export const defaultPollingConfig: PollingConfig = {
  intervalInSeconds: 60,
}
